module.exports = __webpack_public_path__ + "static/img/service-globe.d2fad5e5.png";